import { Icon } from "@opendash/icons";
import { Menu } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { $framework, useNavigation, useTranslation, } from "..";
export const NavigationMenu = observer(function NavigationMenu(props) {
    const t = useTranslation();
    const [groups, items, activeItems] = useNavigation("sidebar");
    function mapGroup(group) {
        var _a, _b, _c, _d;
        return {
            key: group.id,
            label: !group.icon ? (t(group.label)) : (React.createElement("span", null,
                group.icon && React.createElement(Icon, { icon: group.icon }),
                " ",
                t(group.label))),
            onClick: () => { },
            children: [
                ...((_b = (_a = group.children) === null || _a === void 0 ? void 0 : _a.map((route) => {
                    return {
                        key: route.id,
                        label: t(route.label),
                        icon: route.icon ? React.createElement(Icon, { icon: route.icon }) : undefined,
                        onClick: () => {
                            if (route.link && typeof route.link === "string") {
                                $framework.router.navigate(route.link);
                            }
                            else {
                                route.link();
                            }
                        },
                    };
                })) !== null && _b !== void 0 ? _b : []),
                ...((_d = (_c = group.subgroups) === null || _c === void 0 ? void 0 : _c.map(mapGroup)) !== null && _d !== void 0 ? _d : []),
            ],
        };
    }
    return (React.createElement(Menu, Object.assign({ mode: "inline", selectedKeys: activeItems, defaultOpenKeys: groups.map((group) => group.id) }, props, { items: items
            .filter((item) => item.group === null)
            .map((items) => {
            return {
                key: items.id,
                label: !items.icon ? (t(items.label)) : (React.createElement("span", null,
                    items.icon && React.createElement(Icon, { icon: items.icon }),
                    " ",
                    t(items.label))),
                onClick: () => {
                    if (items.link && typeof items.link === "string") {
                        $framework.router.navigate(items.link);
                    }
                    else {
                        items.link();
                    }
                },
            };
        })
            .concat(groups.map(mapGroup)) })));
});
//# sourceMappingURL=NavigationMenu.js.map